import { degreesToRadians } from './degrees-to-radians.js';

var pointFromVector = function (origin, angle, distance) {
    angle = degreesToRadians(angle);
    return {
        x: distance * Math.cos(angle) + origin.x,
        y: distance * Math.sin(angle) + origin.y
    };
};

export { pointFromVector };



//////////////////
// WEBPACK FOOTER
// ./node_modules/popmotion/dist/es/utils/point-from-vector.js
// module id = null
// module chunks = 